import { QCS_HANDOFF_LOGOUT_FLAG, QCS_HANDOFF_SESSION_FLAG } from '../../../configs'

// A logout that never came back must not send a later visit in this tab to QCS.
const QCS_HANDOFF_LOGOUT_TTL_MS = 5 * 60 * 1000

export const markQcsHandoffSession = () => {
  try {
    sessionStorage.setItem(QCS_HANDOFF_SESSION_FLAG, '1')
  } catch {
    // ignore
  }
}

export const isQcsHandoffSession = () => {
  try {
    return sessionStorage.getItem(QCS_HANDOFF_SESSION_FLAG) === '1'
  } catch {
    return false
  }
}

export const clearQcsHandoffSession = () => {
  try {
    sessionStorage.removeItem(QCS_HANDOFF_SESSION_FLAG)
  } catch {
    // ignore
  }
}

export const markQcsHandoffLogout = () => {
  try {
    sessionStorage.setItem(QCS_HANDOFF_LOGOUT_FLAG, String(Date.now()))
  } catch {
    // ignore
  }
}

/** True once, on the first load after a recent handoff Auth0 logout; always clears the flag. */
export const consumeQcsHandoffLogoutReturn = () => {
  try {
    const markedAt = Number(sessionStorage.getItem(QCS_HANDOFF_LOGOUT_FLAG))
    sessionStorage.removeItem(QCS_HANDOFF_LOGOUT_FLAG)
    return markedAt > 0 && Date.now() - markedAt < QCS_HANDOFF_LOGOUT_TTL_MS
  } catch {
    return false
  }
}
